import {
  object,
  optional,
  enum_,
  string,
  union,
  literal,
  type GenericSchema
} from 'valibot'

import { SORT_ORDER_TYPE } from '@/libs/api/types'

export const sorterSchema = object({
  /** ソート項目 */
  sort: optional(string()),
  /** ソート順 */
  order: optional(enum_(SORT_ORDER_TYPE))
})

export const createSorterSchema = <T extends string>(sortKeys: T[]) => {
  return {
    /** ソート項目 */
    sort: optional(
      union(
        sortKeys.map((key) => literal(key)) as unknown as [
          GenericSchema<T>,
          ...GenericSchema<T>[]
        ]
      )
    ),
    /** ソート順 */
    order: optional(enum_(SORT_ORDER_TYPE))
  }
}
